import { useMutation } from '@tanstack/react-query';
import { createFunctionRequest } from '../requests/createFunctionRequest';
import { useNavigate } from 'react-router-dom';
import { FunctionFormProps } from '../types/function.type';
import { Alert } from '../../../components/Alert';
import { queryClient } from '../../../app/App';
import { AxiosError } from 'axios';

export function useCreateFunction() {
	const navigate = useNavigate();

	const createFunction = useMutation({
		mutationFn: async (data: FunctionFormProps) => {
			return createFunctionRequest(data);
		},
		onSuccess: () => {
			Alert({ message: 'Successfully created!', type: 'success' });
			queryClient.invalidateQueries(['RESPONSIBILITY_LIST']);
			navigate(-1);
		},
		onError: (error: AxiosError) => {
			Alert({ message: error.message, type: 'error' });
		},
	});

	return { createFunction };
}
